import config from '../../config';
import { getClientData } from '../clientData';

/**
 * Locale the app should use outside a React/router context: the stored
 * `vansite.locale`, else a supported device language, else the configured
 * fallback.
 */
export const resolveAppLocale = () => {
  const supportedLocales = Object.keys(config.languages || {});
  const deviceLang =
    typeof navigator !== 'undefined' && navigator.language
      ? navigator.language.split('-')[0]
      : null;
  return (
    getClientData('vansite.locale') ||
    (deviceLang && supportedLocales.includes(deviceLang) ? deviceLang : null) ||
    config.fallbackLocale ||
    'de'
  );
};
